import { Record } from "immutable";
import {
  PopinaGroupeInterface,
  PopinaItemInterface,
  PopinaOptionInterface,
  PopinaGroupeOptionInterface,
  PopinaPaymentMethodsInterface,
  PopinaDiscountInterface
} from "./interface";

interface PopinaRestaurantInterface {
  name: string;
  locale: string;
  ticket_city: string;
  category: PopinaGroupeInterface[];
  items: PopinaItemInterface[];
  sharedOptionCategories: PopinaGroupeOptionInterface[];
  optionCategories: PopinaGroupeOptionInterface[];
  paymentMethods: PopinaPaymentMethodsInterface[];
  discounts: PopinaDiscountInterface[];
  menus: any;
  priceTypes: any;
}

export interface PopinaMappedItemInterface {
  id: string;
  name: string;
  category: string;
}

const defaultPopinaRestaurantProps: PopinaRestaurantInterface = {
  name: "test",
  locale: "fr_FR",
  ticket_city: "",
  category: [],
  items: [],
  sharedOptionCategories: [],
  optionCategories: [],
  paymentMethods: [],
  discounts: [],
  menus: [],
  priceTypes: [],
};

export type PopinaOptionType = "shared_option_categories" | "option_categories";

class PopinaRestaurant extends Record(defaultPopinaRestaurantProps)
  implements PopinaRestaurantInterface {

  constructor(props: any) {
    super(PopinaRestaurant.reveiveProps(props));
  }

  private static reveiveProps(props: any): any {
    let data = Object.assign({}, props);
    data["category"] = props["macro_categories"] ?? [];
    data["items"] = (props["items"] ?? ([] as any[])).reduce((accu: any[], i: any) => {
      if (i["macro_category"] !== undefined && i["macro_category"]["client_id"] !== undefined) {
        const item = PopinaRestaurant.reveiveItem(i)
        accu.push(item);
      }

      return accu;
    }, []);
    data["paymentMethods"] = props["payment_methods"] || [];
    data["sharedOptionCategories"] = props["shared_option_categories"] || [];
    data["discounts"] = props["discounts"] || [];
    data["priceTypes"] = props["price_types"] || [];
    data["optionCategories"] = PopinaRestaurant.reveiveOptionCategories(
      props["items"]
    );
    data["menus"] = props?.cards?.length > 0 ? props.cards[0].menus || [] : [];
    return data;
  }

  private static reveiveOptionCategories(items: any = []) {
    return items
      .map((item: any) => item.option_categories)
      .flat()
      .filter((optCat: any) => optCat?.name);
  }

  private static reveiveItem(props: any): any {
    let data = Object.assign({}, props);
    data["categoryID"] = props["macro_category"]["client_id"];
    data["sharedOptionCategories"] = PopinaRestaurant.reveiveGroupeOption(
      props["shared_option_categories"]
    );
    data["optionCategories"] = PopinaRestaurant.reveiveGroupeOption(
      props["option_categories"]
    );
    delete data.shared_option_categories;
    delete data.option_categories;
    delete data.macro_category;
    return data;
  }

  private static reveiveGroupeOption(props: any): string[] {
    return props
      .map((o: any) => o["client_id"])
      .filter(
        (opt: string, index: number, arr: string[]) =>
          index === arr.lastIndexOf(opt)
      );
  }

  getCategoryNameFromID(categoryID: string): string {
    return this.category.find(c => c.client_id === categoryID)?.name ?? "";
  }

  getAllItemForCategory(categoryID: string): PopinaItemInterface[] {
    return this.items.filter(aItem => aItem.categoryID === categoryID);
  }

  getAllMappedItems(): PopinaMappedItemInterface[] {
    return this.items
      .map(i => this.itemToMappedItem(i))
      .concat(this.getAllOptions().map(o => this.optionToMappedItem(o)));
  }

  // renvoie les options en double

  getOptionGroupe(
    groupeOptionId: string,
    type: PopinaOptionType
  ): PopinaGroupeOptionInterface | undefined {
    if (type === "option_categories") {
      return this.optionCategories.find(o => o.client_id === groupeOptionId);
    } else {
      return this.sharedOptionCategories.find(
        o => o.client_id === groupeOptionId
      );
    }
  }

  private itemToMappedItem(
    item: PopinaItemInterface
  ): PopinaMappedItemInterface {
    return {
      id: item.client_id,
      category: this.getCategoryNameFromID(item.categoryID),
      name: item.name
    };
  }

  private optionToMappedItem(option: PopinaOptionInterface) {
    return { id: option.client_id, name: option.name, category: "Options" };
  }

  private getAllOptions(): PopinaOptionInterface[] {
    return this.sharedOptionCategories.reduce(
      (
        accu: PopinaOptionInterface[],
        aSharedOption: PopinaGroupeOptionInterface
      ) => {
        const options = aSharedOption.options.reduce(
          (accu2: PopinaOptionInterface[], aOption: PopinaOptionInterface) => {
            if (accu.find(o => o.name === aOption.name) === undefined) {
              accu2.push(aOption);
            }
            return accu2;
          },
          []
        );

        return accu.concat(options);
      },
      []
    );
  }

  public getAllOptionCategories = () => {
    return [...this.sharedOptionCategories, ...this.optionCategories].filter(
      (opt: any) => opt?.options?.length > 0
    );
  };
}

export default PopinaRestaurant;
